// src/firebase.js
import { app, rtdb, firestore, auth } from "./lib/firebaseClient";

export { app, firestore, auth };
export const db = rtdb;   // keep 'db' as the public name
export default app;
